import { CrudState } from "@/store/crud/State";

export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const IS_CONSUMER_VIEW = "IS_CONSUMER_VIEW";
export const SET_LOGO = "SET_LOGO";
export const SET_LAST_USER_ACTION_TIMESTAMP = "SET_LAST_USER_ACTION_TIMESTAMP";
export const SET_TERMS_OF_USE_ACCEPTED_AT = "SET_TERMS_OF_USE_ACCEPTED_AT";
export const SET_APP_VERSION = "SET_APP_VERSION";
